// extracted by mini-css-extract-plugin
export default {"container":"TextContent_container__ljXc-","content":"TextContent_content__wp-OF"};